/**
 * Показывать ли игроку значок бота.
 *
 * Помечаются «явные» боты рейтинговых матчей (isVisibleBot, см.
 * configs/visibleRankedBots) и боты локальной партии (isLocalBot, ставится в
 * App.handleHotSeatPlayersSubmit). Боты обычных сетевых матчей значка не
 * получают намеренно — рядом с непомеченным участником помеченный читался бы
 * как единственный бот; у обучения, сюжетных миссий и витрины главного меню
 * состав и так известен игроку.
 *
 * Самого isBot в условии НЕТ намеренно: при просмотре записи признак бота
 * гасится (см. GameEndContent), и значок в итогах реплея пропал бы. А то, что
 * значок не достанется живому игроку с бонусом, обеспечено на ЗАПИСИ признака:
 * isLocalBot ставится только боту (App.js и createPlayersState).
 *
 * Тем же значком (только с иконкой ИИ, см. getBotMarkIconPath) помечается
 * LLM-агент промо-матча «Битва с AI» (isAi, аккаунт User.isAi): ботом он не
 * является и ботовую логику не включает — признак здесь только про метку.
 * Поведение ботов по-прежнему решает isVisibleBot/isBot, а не эта функция
 */
export const checkIfBotMarkShown = (player) => Boolean(
  player && (player.isVisibleBot || player.isLocalBot || player.isAi)
);
